import { getTab, getInstitutionCode } from '../appConfig/appConfigForward';


window.appConfig = window.appConfig || ({} as AppConfig);

const uiRouterModule = require('angular-ui-router');
const md5 = require('md5');
import { Injectable, Inject } from 'ng-metadata/core';
import {
    getVid,
    getBeaconInstitutionCode,
    getInstitutionId,
    getCurrentPCKey,
    getCurrentServer,
    getBeaconUrl,
    getCurrentVersionNumber
} from '../appConfig/appConfigForward';
import { SearchFieldsService } from '../search/search.fields.service';
import { UserSessionManagerService } from '../security/userSessionManager.service';
import { SearchStateService } from '../search/searchState.service';
import { SearchService } from '../search/search.service';
import { FullViewPageService } from '../search/fullView/fullViewPage/fullViewPage.service';
import { JwtUtilService } from '../security/jwtUtil.service';
import { ConfigurationUtil } from '../nddUtils/configurationUtil.service';
import { BrowseResultService } from "../search/browse/browseResult/browseResult.service";
import { BrowseSearchBarService } from "../search/browse/browseSearchBar/browseSearchBar.service";
import { StorageUtil } from "../infra/storageUtil.service";
import { STATE_NAMES } from "../primoExplore/primoExploreStates.module";
import { CollectionDiscoveryService, ICDCollectionObject } from "../collectionDiscovery/collectionDiscovery.service";
import { NewspapersService } from '../newspapers/newspapers.service';
import { FullViewLinksService } from '../search/fullView/links/serviceLinks.service';
import { FacetService } from '../search/facet/facet.service';
import { CitationTrailsExpandButtonService } from '../search/citationTrails/citationTrailsExpandButton.service';
import { QuickLink } from '../search/quickLink/quickLink.service';

const he = require('he');
const isEqual = require('lodash/isEqual');
const isEmpty = require('lodash/isEmpty');
const indexOf = require('lodash/indexOf');
const flatten = require('lodash/flatten');
const get = require('lodash/get');
const dateFormat = require('dateformat');
var angular: angular.IAngularStatic = require('angular');


@Injectable()
export class PrimolyticsService {

    private beaconBaseUrl: string;
    private op: string;
    private session: string;
    private originalMethodArgs: any[];
    private resourceRecommenderFields: String[] = ["database", "person", "website", "library_information", "library_guide", "custom1", "custom2", "custom3"];
    private institutionServer;
    private needToGetReferrer: boolean;
    private urlPrefixPattern = /(^((http|https):\/\/|www\.))/i;
    private urlSuffixPattern = /\/$/i;

    constructor(private searchFieldsService: SearchFieldsService,
        @Inject('$translate') private $translate: ng.translate.ITranslateService,
        private userSessionManagerService: UserSessionManagerService,
        private searchStateService: SearchStateService,
        private searchService: SearchService,
        private facetService: FacetService,
        private collectionDiscoveryService: CollectionDiscoveryService,
        private newspapersService: NewspapersService,
        private linksService: FullViewLinksService,
        @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        private fullViewPageService: FullViewPageService,
        @Inject('$state') private $state: ng.ui.IStateService,
        private jwtUtilService: JwtUtilService,
        @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
        private configurationUtil: ConfigurationUtil,
        private browseResultService: BrowseResultService,
        private browseSearchBarService: BrowseSearchBarService,
        private storageUtil: StorageUtil,
        private citationTrailsExpandButtonService: CitationTrailsExpandButtonService,
        private quickLinksService: QuickLink) {

        this.beaconBaseUrl = getBeaconUrl() || 'http://1234.exlibrisgroup.com';
        this.needToGetReferrer = true;
    }

    /*
     * calls upon async check for initial URL to match any deeplink value and report to beacon
     */
    trackInitialPage() {
        this.$rootScope.$evalAsync(() => {
            let watchInitialPageLoad = this.$rootScope.$on('$viewContentLoaded', () => this.reportDeepLinks());
            watchInitialPageLoad();
        });
    }

    private reportDeepLinks(event?, toState?, toParams?, fromState?, fromParams?) {
        let currentUrl = window.location.toString();

        if ((currentUrl.indexOf('vid=')) !== -1) {

            let startTime = new Date().getTime();

            let mappingJson = this.getMappingJson();
            let p = currentUrl.substring(currentUrl.lastIndexOf('\/') + 1, currentUrl.lastIndexOf('\?') + 1); //get the page name, 'search', 'fullview', etc...

            if (mappingJson[p]) {
                mappingJson[p].apply(this, [currentUrl, startTime]); //run the beacon reporting logic
            }
        }
    }

    getSearchService() {
        return this.searchService;
    }

    getScope() {
        return this.$rootScope;
    }
    openFullObject(type: string, op: string): Object {
        let generalFull =
        {
            OP: "openfull",
            O1: () => {
                return this.getSourceOfTheRecord();
            },
            O2: (item) => {
                return this.getItemDataScope(item);
            },
            O3: (item) => {
                return this.getIdOfRecord(item);
            },
            O4: (item) => {
                return this.op === 'favorites' ? this.getFavoritesAction(item) : undefined;
            },
            O6: (item) => {
                return this.getGIDOfRecord(item);
            },
            O10: (item) => {
                return this.getOnlineOrPhysical(item);
            },
            O13: (item) => {
                return this.getRecordDataSource(item);
            },
            O14: (item) => {
                return this.getJournalOfRecord(item);
            },
            O15: (item) => {
                return this.getIssnOfRecord(item);
            },
            O16: (item) => {
                return this.getEIssnOfRecord(item);
            },
            O22: (items) => {
                return this.getServerTime(items);
            },
            O40: () => {
                return this.getSearchTermsFromUrl();
            },
            O41: (item) => {
                return this.getTitleOfRecord(item);
            },
            O42: (item) => {
                return this.getPublisherOfRecord(item);
            },
            O43: (item) => {
                return this.getIsCdiRecord(item);
            },
            P: () => {
                return this.checkIfCitationTrail(this.op)
            },
            PV: () => {
                return this.getViewItTimes();
            },
            PG: () => {
                return this.getGetItTimes();
            },
            PCD: () => {
                return this.getPCTimes();
            }
        };
        if (type === 'servicespage') {
            generalFull['SPG'] = 'Y';
        }
        if (type === 'servicespage' || op === 'deeplink') {
            generalFull['DL'] = 'Y';
        }
        return generalFull;
    }
    // There is an 'item' parameter in the function which is not in the scope of this function, so we add
    // the 'itemArg' to the function so that this will be in the scope (currently required only for sticky facets)
    getMappingJson(itemArg?) {
        return {

            /* === INITIAL PAGE LOAD OPERATIONS (deeplinks) ARE DEFINED BELOW === */

            'recommender': {
                O5: (item) => {
                    return encodeURIComponent(item.link1);
                },
                O3: (item) => {
                    return item.sourceid
                },
                O2: (item) => {
                    return item.index.toString()
                },
            },

            'search?': (currentUrl: string, startTime: number) => {
                if (urlContainsParams(currentUrl, 'query=', 'search_scope=')) {
                    if (urlContainsParams(currentUrl, 'facet=')) {
                        //this is a facet deeplink, i guess we report it as facet
                        let facetArray = currentUrl.substr(currentUrl.indexOf('facet=')).split('facet=') //get facet array
                        let facet = this.searchService.getFacetsFromUrl(decodeURIComponent(facetArray[facetArray.length - 1]), false)[0]; // decode last facet

                        if (facet.name === 'frbrgroupid') { // frbr type facet
                            this.doBeaconReportWaitForFacetSearch({ 'p': 'refine', 'op': 'frbr' }, undefined, startTime);
                        } else if (facet.name === 'include') { //include type facet
                            this.doBeaconReportWaitForFacetSearch({
                                'p': 'refine',
                                'op': 'facetInclude'
                            }, undefined, startTime);
                        } else { //exclude type facet
                            this.doBeaconReportWaitForFacetSearch({
                                'p': 'refine',
                                'op': 'facetExclude'
                            }, undefined, startTime);
                        }
                    } else {
                        this.doBeaconReportWaitForSearch({ 'p': 'search', 'op': 'do' }, '', startTime);
                    }
                }
            },
            'fulldisplay?': (currentUrl: string, startTime: number) => {
                if (urlContainsParams(currentUrl, 'docid=', 'context=', 'search_scope=')) {
                    this.doBeaconReportWaitForFullView({ 'p': 'brief', 'op': 'openfull' }, '', startTime);
                }
            },
            'account?': (currentUrl: string, startTime: number) => {
                let selectedTab = /section=([^&]+)/.exec(window.location.toString())[1];
                if (!isEmpty(selectedTab)) {
                    this.doBeaconReport({ 'p': 'general', 'op': 'menu.myaccount.' + selectedTab }, '', startTime);
                } else {
                    this.doBeaconReport({ 'p': 'general', 'op': 'gotoMyAccount' }, '', startTime);
                }
            },
            'collectionDiscovery?': (currentUrl: string, startTime: number) => {
                if (urlContainsParams(currentUrl, 'colayout=', 'inst=', 'collectionId=')) {
                    this.doBeaconReport({ 'p': 'general', 'op': '???' });
                }
            },
            'favorites?': (currentUrl: string, startTime: number) => {
                if (urlContainsParams(currentUrl, 'label=')) {
                    this.doBeaconReport({ 'p': 'general', 'op': 'gotoeShelf' }, '', startTime);
                }
            },
            'colldisc': {
                displayCollection: {
                    O: (collection) => {
                        return this.getCollectionNameForBeacon(collection);
                    }
                },
                favorites: {
                    OP: ()=> {
                        return ((this.searchService.cameFromState == 'collection') ? 'favoritesAddCollection' : 'favoritesAddItem')
                    },
                    O: (collection)=> {
                        return this.getCollectionNameForBeacon(collection);
                    }
                },
                changeView: {
                    OP: () => {
                        return 'changeViewTo' + this.collectionDiscoveryService.itemsViewStyle;
                    },
                },
                refine: {
                    OP: "refine",
                },
                sortCollectionsBy: {
                    OP: () => {
                        return this.originalMethodArgs.length === 1 ? 'sortCollectionsBy' + this.originalMethodArgs[0] : undefined
                    }
                },
                sortItemsBy: {
                    OP: () => {
                        return this.originalMethodArgs.length === 1 ? 'sortItemsBy' + this.originalMethodArgs[0] : undefined
                    }
                }
            },
            'TimesCited': {
                O1: () => {
                    return this.getSourceOfTheRecord();
                },
                O2: () => {
                    return this.getSearchScope();
                },
                O3: (item) => {
                    return this.getIdOfRecord(item);
                },
                O6: (item) => {
                    return this.getGIDOfRecord(item);
                },
                O13: (item) => {
                    return this.getRecordDataSource(item);
                },
                O14: (item) => {
                    return this.getJournalOfRecord(item);
                },
                O15: (item) => {
                    return this.getIssnOfRecord(item);
                },
                O16: (item) => {
                    return this.getEIssnOfRecord(item);
                },


            },
            'researchAssistant': {
                O3: (item) => {
                    return this.getRARecordId(item);
                },
                O8: (item) => {
                    return this.getRAQuestion(item);
                }
            },
            'rssSubscription': {
                O1: () => {
                    return this.getSourceOfTheRecord();
                },
                O2: () => {
                    return this.getSearchScope();
                },
                O3: () => {
                    return this.getNumberOfResults();
                },
                O4: () => {
                    return this.getFieldSearchedFromUrl();
                },//{return this.getFieldSearched();},
                O8: () => {
                    return this.getSearchTermsFromUrl();
                },//{return this.getSearchTerm();},
                O10: () => {
                    return this.getResourceTypePreFilterFromUrl();
                },//{return this.getResourceTypePreFilter();},
                O11: () => {
                    return this.getSearchTypeFromUrl();
                },//{return this.getSearchType();},
                O17: () => {
                    return this.getSearchTab();
                },
                O19: () => {
                    return this.getPercentOfContentBySource();
                },
                O22: () => {
                    return this.getServerTime();
                },

                'click': {
                    O22: (items) => {
                        return this.getServerTime(items);
                    },
                }
            },


            /* === CLICK TYPE OPERATIONS ARE DEFINED BELOW === */

            'search': {
                O1: () => {
                    return this.getSourceOfTheRecord();
                },
                O2: () => {
                    return this.getSearchScope();
                },
                O3: () => {
                    return this.getNumberOfResults();
                },
                O4: () => {
                    return this.getFieldSearchedFromUrl();
                },//{return this.getFieldSearched();},
                O8: () => {
                    return this.getSearchTermsFromUrl();
                },//{return this.getSearchTerm();},
                O10: () => {
                    return this.getResourceTypePreFilterFromUrl();
                },//{return this.getResourceTypePreFilter();},
                O11: () => {
                    return this.getSearchTypeFromUrl();
                },//{return this.getSearchType();},
                O17: () => {
                    return this.getSearchTab();
                },
                O19: () => {
                    return this.getPercentOfContentBySource();
                },
                O22: (items) => {
                    return this.getServerTime(items);
                },
                O37: (items) => {
                    return this.getStickyFacetsUsedOnZeroResults(items);
                },
                O38: () => {
                    return this.getSearchActionType();
                },//currently only for voice search
                O40: () => {
                    return this.getRecommendationCount(this.resourceRecommenderFields[0]);
                },
                O41: () => {
                    return this.getRecommendationCount(this.resourceRecommenderFields[1]);
                },
                O42: () => {
                    return this.getRecommendationCount(this.resourceRecommenderFields[2]);
                },
                O43: () => {
                    return this.getRecommendationCount(this.resourceRecommenderFields[3]);
                },
                O44: () => {
                    return this.getRecommendationCount(this.resourceRecommenderFields[4]);
                },
                O45: () => {
                    return this.getRecommendationCount(this.resourceRecommenderFields[5]);
                },
                O46: () => {
                    return this.getRecommendationCount(this.resourceRecommenderFields[6]);
                },
                O47: () => {
                    return this.getRecommendationCount(this.resourceRecommenderFields[7]);
                },
                O48: () => {
                    return this.getBeaconSearchErrorMessage();
                },
                lateralLinking: { // lateralLinkingt has a whole other set of 'O's
                    OP: "lateralLinking",
                    O1: () => {
                        return this.getSourceOfTheRecord();
                    },
                    O2: () => {
                        return this.getSearchScope();
                    },
                    O3: () => {
                        return this.getNumberOfResults();
                    },
                    O4: () => {
                        return this.originalMethodArgs.length > 0 ? this.originalMethodArgs[0] : undefined;
                    },
                    O8: () => {
                        return this.getSearchTerm();
                    },
                    O10: () => {
                        return this.getResourceTypePreFilter();
                    },
                    O11: () => {
                        return this.originalMethodArgs.length > 1 && this.originalMethodArgs[1] ? 'facet exact' : this.getSearchTypeFromUrl();
                    },
                    O13: (item) => {
                        return this.getRecordDataSource(item);
                    },
                    O14: (item) => {
                        return this.getJournalOfRecord(item);
                    },
                    O15: (item) => {
                        return this.getIssnOfRecord(item);
                    },
                    O16: (item) => {
                        return this.getEIssnOfRecord(item);
                    },
                    O22: () => {
                        return this.getServerTime();
                    } //lateralLinking creates a search, so get O22 from search results
                },

                browseRelated: {
                    OP: "browseRelated",
                    O: () => {
                        return this.getInstNameForBeacon();
                    },
                    //O2: () => {return this.browseRecordSource();},
                    O8: () => {
                        return this.getBrowseQuery();
                    }
                },
                browse: {
                    OP: () => {
                        return 'browse_' + this.browseSearchBarService.selectedScope['SourceCode1']
                    },
                    O: () => {
                        return this.getInstNameForBeacon();
                    },
                },
                atoz: {
                    OP: () => {
                        return this.getATOZSearchOP();
                    },
                    O2: "primo_alma",
                    O3: () => {
                        return this.getNumberOfResults();
                    },
                    O8: () => {

                        let azletter = this.getAtozSearchTerm()
                        if (azletter.length > 1 && azletter !== 'Others' && azletter !== '0-9' && this.searchStateService.getSearchObject().journals.startsWith("letter,")) {
                            azletter = azletter.substring(4);
                        }
                        return azletter;
                    },
                    O: () => {

                        let azletter = this.getAtozSearchTerm()
                        if (azletter.length > 1 && azletter !== 'Others' && azletter !== '0-9' && this.searchStateService.getSearchObject().journals.startsWith("letter,")) {
                            azletter = azletter.substring(4);
                        }
                        return azletter;
                    },
                    O10: () => {
                        let lang = this.getAtozSearchTerm();
                        if (lang.length > 1 && lang !== 'Others' && lang !== '0-9') {
                            lang = lang.substring(0, 2) + "_" + lang.substring(2, 4).toUpperCase();
                        } else {
                            if (lang === 'Å' || lang === 'Æ' || lang === 'Ø') {
                                lang = 'no_NO';
                            } else {
                                lang = 'en_US';
                            }
                        }
                        return this.configurationUtil.isSuprima() ? this.getSuprimaAtozLang() : lang;
                    }
                },
                newspapers: {
                    OP: "newspapers",
                    O1: "deep_search",
                    O2: () => {
                        return this.getSearchScope() + ((this.getSearchScope() != 'all') ? ' <' + this.newspapersService.featuredScope + '>' : '');
                    },
                    O3: () => {
                        return this.getNumberOfResults();
                    },
                    O8: () => {
                        return this.getSearchTermsFromUrl();
                    }
                },
                azdb: {
                    OP: () => {
                        return this.getDBSearchOP();
                    },
                    O2: "primo_alma",
                    O3: () => {
                        return this.getNumberOfResults();
                    },
                    O8: () => {
                        return this.getAtozSearchTerm();
                    },
                    O10: () => {
                        return this.getDBSearchType();
                    }
                },
                dbCategoryExpand: {
                    OP: "azdbDbCategoryExpend"
                },
                sessionQuery: { // used for search history query invocation
                    OP: "sessionQuery",
                    O1: () => {
                        return "deep_search";
                    },
                    O2: () => {
                        return this.getSearchScope();
                    },
                    O3: () => {
                        return this.getNumberOfResults();
                    },
                    O4: () => {
                        return this.getFieldSearchedFromUrl();
                    },
                    O6: '',
                    O8: () => {
                        return this.getSearchTermsFromUrl();
                    },
                    O10: '',
                    O11: '',
                    O13: '',
                    O14: '',
                    O15: '',
                    O16: '',
                    O17: '',
                    O18: 'UI',
                    O19: '',
                    O20: '',
                    O21: 'NUI',
                    O22: '',
                    O23: ''
                },
                savedQuery: { // used for search history query invocation
                    OP: "savedQuery",
                    O1: () => {
                        return "deep_search";
                    },
                    O2: () => {
                        return this.getSearchScope();
                    },
                    O3: () => {
                        return this.getNumberOfResults();
                    },
                    O4: () => {
                        return this.getFieldSearchedFromUrl();
                    },
                    O6: '',
                    O8: () => {
                        return this.getSearchTermsFromUrl();
                    },
                    O10: '',
                    O11: '',
                    O13: '',
                    O14: '',
                    O15: '',
                    O16: '',
                    O17: '',
                    O18: 'UI',
                    O19: '',
                    O20: '',
                    O21: 'NUI',
                    O22: '',
                    O23: ''
                },
                searchInCollection: {
                    OP: "searchInCollection",
                    O8: () => {
                        return this.getCollectionSearchTerm();
                    },
                    O: (collection) => {
                        return this.getCollectionNameForBeacon(collection);
                    }
                },
                preFilter: {
                    OP: "preFilter",
                    O1: () => {
                        return this.getSearchScopeType();
                    }
                },
                authoritySearch: {
                    OP: "authoritySearch",
                    O: (item) => {
                        return item;
                    }
                }
            },
            'deeplink': {
                'openfull': this.openFullObject('openfull', 'deeplink'),
                'servicespage': this.openFullObject('servicespage', 'deeplink')
            },
            'brief': {
                O1: () => {
                    return this.getSourceOfTheRecord();
                },
                O2: (item) => {
                    return this.getItemDataScope(item);
                },
                O3: (item) => {
                    return this.getIdOfRecord(item);
                },
                O4: (item) => {
                    return this.op === 'favorites' ? this.getFavoritesAction(item) : undefined;
                },
                O6: (item) => {
                    return this.getGIDOfRecord(item);
                },
                O10: (item) => {
                    return this.getOnlineOrPhysical(item);
                },
                O13: (item) => {
                    return this.getRecordDataSource(item);
                },
                O14: (item) => {
                    return this.getJournalOfRecord(item);
                },
                O15: (item) => {
                    return this.getIssnOfRecord(item);
                },
                O16: (item) => {
                    return this.getEIssnOfRecord(item);
                },
                O22: (items) => {
                    return this.getServerTime(items);
                },
                P: () => {
                    return this.checkIfCitationTrail(this.op)
                },
                icon: {
                    OP: "icon",
                },
                title: {
                    OP: "title",
                },
                next: { // next has a whole other set of 'O's
                    OP: "next",
                    O1: () => {
                        return this.getSearchScopeType();
                    },
                    O2: () => {
                        return this.getSearchScope();
                    },
                    O8: () => {
                        return this.getSearchTerm();
                    },
                    O22: (items) => {
                        return this.getServerTime(items);
                    }
                },
                linktoPath: {
                    OP: "linktoPath",
                    O: (collection) => {
                        return this.getCollectionNameForBeacon(collection);
                    }
                },
                linktoCollection: {
                    OP: "linktoCollection",
                    O: (collection) => {
                        return this.getCollectionNameForBeacon(collection);
                    }
                },
                nextResult: {
                    OP: "nextResult",
                    O1: () => {
                        return this.getSearchScopeType();
                    },
                    O2: () => {
                        return this.getSearchScope();
                    },
                    O8: () => {
                        return this.getSearchTerm();
                    },
                    O22: (items) => {
                        return this.getServerTime(items);
                    }
                },
                previousResult: {
                    OP: "previousResult",
                    O1: () => {
                        return this.getSearchScopeType();
                    },
                    O2: () => {
                        return this.getSearchScope();
                    },
                    O8: () => {
                        return this.getSearchTerm();
                    },
                    O22: (items) => {
                        return this.getServerTime(items);
                    }
                },
                resourceRecommender: {
                    OP: (item) => {
                        return "resourceRecommender_" + item.resourceType;
                    },
                },
                numOfResults: {
                    OP: "numOfResults",
                },
                resourceRecommenderDisplayed: {
                    O8: () => {
                        return this.getSearchTermsFromUrl();
                    },
                },
                openfull: this.openFullObject('openfull')
                ,
                checkOnlineFromOthers: {
                    OP: "checkOnlineFromOthers",
                },
                checkOnlineFromOthersCampuses: {
                    OP: "checkOnlineFromOthersCampuses",
                },
                ClickOnFilter: {
                    OP: 'ClickOnFilter'
                },
                servicesNavigation: {
                    OP: 'servicesNavigation'
                }
            },
            'sort': {
                OP: () => {
                    return this.getSortType();
                },
                O1: () => {
                    return this.getSourceOfTheRecord();
                },
                O2: () => {
                    return this.getSearchScope();
                },
                O3: () => {
                    return this.getNumberOfResults();
                },
                O4: () => {
                    return this.getFieldSearched();
                },
                O8: () => {
                    return this.getSearchTerm();
                },
                O10: () => {
                    return this.getResourceTypePreFilter();
                },
                O11: () => {
                    return this.getSearchType();
                },
                O19: () => {
                    return this.getPercentOfContentBySource();
                },
                O22: () => {
                    return this.getServerTime();
                }
            },
            'general': {
                O: () => {
                    return ((this.op === 'signIn' || this.op === 'gotoSearch') ? this.getCurrentLocation() : undefined)
                },
                O1: () => {
                    return ((this.op === 'gotoSearchHistory') ? "deep_search" : undefined)
                },
                O2: () => {
                    return ((this.op === 'gotoSearchHistory') ? this.getSearchScope() : undefined)
                },
                O4: () => {
                    return this.getCurrentLang();
                },
                goToNewspapersfromMainMenu: {
                    OP: "goToNewspapersfromMainMenu",
                },
                goToNewspapersfromRegularSearch: {
                    OP: "goToNewspapersfromRegularSearch",
                    O1: () => {
                        return this.newspapersService.regularSearchCameFrom;
                    },
                },
                mainMenuLink: {
                    OP: () => {
                        return "mainMenuLink" + this.searchService.cameFromState;
                    },
                },
                sortEshelfdate: {
                    OP: "sortEshelfdate",
                },
                sortEshelfTitle: {
                    OP: "sortEshelfTitle",
                },
                sortEshelfAuthor: {
                    OP: "sortEshelfAuthor",
                },
                goToRefworks: {
                    OP: "goToRefworks",
                },
                resourceExistLink: {
                    OP: "resourceExistLink",
                },
            },
            'fullshortcuts': {
                OP: () => {
                    return (this.originalMethodArgs.length === 1 ? this.originalMethodArgs[0] : undefined)
                },
                O1: () => {
                    return this.getSourceOfTheRecord();
                },
                O2: (item) => {
                    return this.getItemDataScope(item);
                },
                O3: (item) => {
                    return this.getIdOfRecord(item);
                },
                O6: (item) => {
                    return this.getGIDOfRecord(item);
                },
                O13: (item) => {
                    return this.getRecordDataSource(item);
                },
                O14: (item) => {
                    return this.getJournalOfRecord(item);
                },
                O15: (item) => {
                    return this.getIssnOfRecord(item);
                },
                O16: (item) => {
                    return this.getEIssnOfRecord(item);
                },
                O22: (items) => {
                    return this.getServerTime(items);
                }
            },
            'getIt1': {
                O1: () => {
                    return this.getSourceOfTheRecord();
                },
                O2: (item) => {
                    return this.getItemDataScope(item);
                },
                O3: (item) => {
                    return this.getIdOfRecord(item);
                },
                O4: "???", //TODO
                O6: (item) => {
                    return this.getGIDOfRecord(item);
                },
                O13: (item) => {
                    return this.getRecordDataSource(item);
                },
                O14: (item) => {
                    return this.getJournalOfRecord(item);
                },
                O15: (item) => {
                    return this.getIssnOfRecord(item);
                },
                O16: (item) => {
                    return this.getEIssnOfRecord(item);
                },
                O22: (items) => {
                    return this.getServerTime(items);
                }
            },
            'linksService': {
                O1: () => {
                    return this.getSourceOfTheRecord();
                },
                O2: () => {
                    return this.getSearchScope();
                },
                O3: (item) => {
                    return this.getIdOfRecord(item);
                },
                O4: '', //TODO
                O6: (item) => {
                    return this.getGIDOfRecord(item);
                },
                O8: () => {
                    return this.getSearchTerm();
                },
                O13: (item) => {
                    return this.getRecordDataSource(item);
                },
                O14: (item) => {
                    return this.getJournalOfRecord(item);
                },
                O15: (item) => {
                    return this.getIssnOfRecord(item);
                },
                O16: (item) => {
                    return this.getEIssnOfRecord(item);
                },
                O22: (items) => {
                    return this.getServerTime(items);
                },
                linkToLeganto: {
                    OP: "linkToLeganto",
                },
                 QuicklinkPDF: {
                    O: (item) => {
                        return this.quickLinksService.getLinkProvider(item , 'pdf');
                    },
                    O1: () => {
                        return this.getSourceOfTheRecord();
                    },
                    O2: () => {
                        return this.getSearchScope();
                    },
                    O3: (item) => {
                        return this.getIdOfRecord(item);
                    },
                    O4: '', //TODO
                    O6: (item) => {
                        return this.getGIDOfRecord(item);
                    },
                    O8: () => {
                        return this.getSearchTerm();
                    },
                    O13: (item) => {
                        return this.getRecordDataSource(item);
                    },
                    O14: (item) => {
                        return this.getJournalOfRecord(item);
                    },
                    O15: (item) => {
                        return this.getIssnOfRecord(item);
                    },
                    O16: (item) => {
                        return this.getEIssnOfRecord(item);
                    },
                    O22: (items) => {
                        return this.getServerTime(items);
                    }   
                },
                QuicklinkHTML: {
                    O: (item) => {
                        return this.quickLinksService.getLinkProvider(item , 'html');
                    }, 
                    O1: () => {
                        return this.getSourceOfTheRecord();
                    },
                    O2: () => {
                        return this.getSearchScope();
                    },
                    O3: (item) => {
                        return this.getIdOfRecord(item);
                    },
                    O4: '', //TODO
                    O6: (item) => {
                        return this.getGIDOfRecord(item);
                    },
                    O8: () => {
                        return this.getSearchTerm();
                    },
                    O13: (item) => {
                        return this.getRecordDataSource(item);
                    },
                    O14: (item) => {
                        return this.getJournalOfRecord(item);
                    },
                    O15: (item) => {
                        return this.getIssnOfRecord(item);
                    },
                    O16: (item) => {
                        return this.getEIssnOfRecord(item);
                    },
                    O22: (items) => {
                        return this.getServerTime(items);
                    }
                }
            },
            'myAccount': {
                renewLoans: {
                    OP: "renewLoans",
                },
                cancelRequest: {
                    OP: "cancelRequest",
                },
            },
            'tags': {},
            'refine': {
                OP: (facet) => {
                    return this.getFacetAction(facet);
                },
                O: (facet) => {
                    return this.getFacetAddOrRemove(facet);
                },
                O1: () => {
                    return this.getSearchScopeType();
                },
                O2: () => {
                    return this.getSearchScope();
                },
                O3: () => {
                    return this.getNumberOfResults();
                },
                O4: () => {
                    return this.getFieldSearched();
                },
                O8: () => {
                    return this.getSearchTerm();
                },
                O10: () => {
                    return this.getResourceTypePreFilter()
                },
                O11: () => {
                    return this.getSearchType();
                },
                O13: (facet) => {
                    return this.getFacetName(facet);
                },
                O17: () => {
                    return this.getSearchTab();
                },
                O19: () => {
                    return this.getPercentOfContentBySource();
                },
                O20: (facet) => {
                    return this.getFacetValue(facet);
                },
                O22: () => {
                    return this.getServerTime();
                }, //faceting creates a search, so get O22 from search results
                O50: (facet) => {
                    if (facet.ignoreInActions) {
                        return "ignoreInActions";
                    } else return "Not Defined"
                },

                frbr: { // frbr has a whole other set of 'O's
                    OP: "frbr",
                    O: (item) => {
                        return this.getFacetAddOrRemove(item);
                    },
                    O1: () => {
                        return this.getSourceOfTheRecord();
                    },
                    O2: (item) => {
                        return this.getSearchScope();
                    },
                    O3: (item) => {
                        return this.getIdOfRecord(item);
                    },
                    O13: (item) => {
                        return this.getRecordDataSource(item);
                    },
                    O14: (item) => {
                        return this.getJournalOfRecord(item);
                    },
                    O15: (item) => {
                        return this.getIssnOfRecord(item);
                    },
                    O16: (item) => {
                        return this.getEIssnOfRecord(item);
                    },
                    O17: () => {
                        return this.getSearchTab();
                    },
                    O22: () => {
                        return this.getServerTime();
                    }, //faceting creates a search, so get O22 from search results
                }
            },
            'setPersistentFacet': {
                O: () => {
                    return this.getFacetAddOrRemove(itemArg);
                },
                O1: () => {
                    return this.getSearchScopeType();
                },
                O2: () => {
                    return this.getSearchScope();
                },
                O3: () => {
                    return this.getNumberOfResults();
                },
                O4: () => {
                    return this.getFieldSearched();
                },
                O8: () => {
                    return this.getSearchTerm();
                },
                O10: () => {
                    return this.getResourceTypePreFilter()
                },
                O11: () => {
                    return this.getSearchType();
                },
                O13: () => {
                    return this.getFacetName(itemArg);
                },
                O17: () => {
                    return this.getSearchTab();
                },
                O19: () => {
                    return this.getPercentOfContentBySource();
                },
                O20: () => {
                    return this.getFacetValue(itemArg);
                },
                O22: () => {
                    return this.getServerTime();
                } //faceting creates a search, so get O22 from search results
            },
            'persistent': {
                OP: () => {
                    return this.getFacetAction(itemArg);
                },
                O: () => {
                    return this.getFacetAddOrRemove(itemArg);
                },
                O1: () => {
                    return this.getSearchScopeType();
                },
                O2: () => {
                    return this.getSearchScope();
                },
                O3: () => {
                    return this.getNumberOfResults();
                },
                O4: () => {
                    return this.getFieldSearched();
                },
                O8: () => {
                    return this.getSearchTerm();
                },
                O10: () => {
                    return this.getResourceTypePreFilter()
                },
                O11: () => {
                    return this.getSearchType();
                },
                O13: () => {
                    return this.getFacetName(itemArg);
                },
                O17: () => {
                    return this.getSearchTab();
                },
                O19: () => {
                    return this.getPercentOfContentBySource();
                },
                O20: () => {
                    return this.getFacetValue(itemArg);
                },
                O22: () => {
                    return this.getServerTime();
                }, //faceting creates a search, so get O22 from search results
                O50: "ignoreInActions"
            },
            'sendTo': {
                O1: () => {
                    return this.getSourceOfTheRecord();
                },
                O2: (item) => {
                    return this.getItemDataScope(item);
                },
                O3: (item) => {
                    return this.getIdOfRecord(item);
                },
                O6: (item) => {
                    return this.getGIDOfRecord(item);
                },
                O8: (item) => {
                    return (this.op === 'Citation') ? item.citationStyle : undefined;
                },
                O13: (item) => {
                    return this.getRecordDataSource(item);
                },
                O14: (item) => {
                    return this.getJournalOfRecord(item);
                },
                O15: (item) => {
                    return this.getIssnOfRecord(item);
                },
                O16: (item) => {
                    return this.getEIssnOfRecord(item);
                },
                O22: (items) => {
                    return this.getServerTime(items);
                }
            },

            'click': {
                O: () => {
                    return this.getInstNameForBeacon();
                }
            },
            'citation-linker': {},
            'personalizedResults': {},
            'voiceSearch': {},
            'virtualBrowse': {
                O1: () => {
                    return this.getSourceOfTheRecord();
                },
                O2: () => {
                    return this.getSearchScope();
                },
                O3: (item) => {
                    return this.getIdOfRecord(item);
                },
                O6: (item) => {
                    return this.getGIDOfRecord(item);
                },
                O10: (item) => {
                    return this.getOnlineOrPhysical(item);
                },
                O13: (item) => {
                    return this.getRecordDataSource(item);
                },
                O14: (item) => {
                    return this.getJournalOfRecord(item);
                },
                O15: (item) => {
                    return this.getIssnOfRecord(item);
                },
                O16: (item) => {
                    return this.getEIssnOfRecord(item);
                },
                O22: (items) => {
                    return this.getServerTime(items);
                },
                recordVirtualBrowse: {
                    OP: "recordVirtualBrowse",
                    O1: () => {
                        return this.getSourceOfTheRecord();
                    },
                    O2: () => {
                        return this.getSearchScope();
                    },
                    O3: () => {
                        return this.originalMethodArgs.length === 1 ? this.originalMethodArgs[0] : undefined;
                    }
                }
            },
            'moreFromTheSame': {
                O1: () => {
                    return this.getSourceOfTheRecord();
                },
                O2: () => {
                    return this.getSearchScope();
                },
                O3: (item) => {
                    return this.getIdOfRecord(item);
                },
                O6: (item) => {
                    return this.getGIDOfRecord(item);
                },
                O10: (item) => {
                    return this.getOnlineOrPhysical(item);
                },
                O13: (item) => {
                    return this.getRecordDataSource(item);
                },
                O14: (item) => {
                    return this.getJournalOfRecord(item);
                },
                O15: (item) => {
                    return this.getIssnOfRecord(item);
                },
                O16: (item) => {
                    return this.getEIssnOfRecord(item);
                },
                O22: (items) => {
                    return this.getServerTime(items);
                },
                recordMoreFromTheSame: {
                    OP: "recordMoreFromTheSame",
                    O1: () => {
                        return this.getSourceOfTheRecord();
                    },
                    O2: () => {
                        return this.getSearchScope();
                    },
                    O3: () => {
                        return this.originalMethodArgs.length === 1 ? this.originalMethodArgs[0] : undefined;
                    }
                }
            },
            'featuredResults': {
                O1: () => {
                    return this.getSourceOfTheRecord();
                },
                O2: () => {
                    return this.getSearchScope();
                },
                O3: (item) => {
                    return this.getIdOfRecord(item);
                },
                O6: (item) => {
                    return this.getGIDOfRecord(item);
                },
                O10: (item) => {
                    return this.getOnlineOrPhysical(item);
                },
                O13: (item) => {
                    return this.getRecordDataSource(item);
                },
                O14: (item) => {
                    return this.getJournalOfRecord(item);
                },
                O15: (item) => {
                    return this.getIssnOfRecord(item);
                },
                O16: (item) => {
                    return this.getEIssnOfRecord(item);
                },
                O22: (items) => {
                    return this.getServerTime(items);
                },
                recordFeaturedResults: {
                    OP: "recordFeaturedResults",
                    O1: () => {
                        return this.getSourceOfTheRecord();
                    },
                    O2: () => {
                        return this.getSearchScope();
                    },
                    O3: () => {
                        return this.originalMethodArgs.length === 1 ? this.originalMethodArgs[0] : undefined;
                    }
                }
            },
            'detailsTab': {},
            'relatedPerson': {},
            'citationTrail': {
                O: () => {
                    return this.getCitationTrailExpandAction();
                }
            }
        };
    }


    public getInstNameForBeacon() {
        let code = getInstitutionCode();
        let fullName = this.$translate.instant(code);
        return encodeURIComponent('&&&&' + code + '&' + fullName + '&&');
    }
   
    public getCollectionNameForBeacon(collection) {
        let collectionNameFromPnx = get(collection, 'pnx.display.title[0]');
        if (!isEmpty(collection)) {
            if (collection.name != null) {
                return collection.name.replace(/&/g, '%26');
            }
            else if (!isEmpty(collectionNameFromPnx)) {
                return collectionNameFromPnx.replace(/&/g, '%26');
            }
        }
        return null;
    }

    /*
     * iterates over the beacon MappingJson, invoking the actions listed for each parameter
     */
    private getParamsFromMapping(elem, item?) {

        if (elem.OP) {
            this.op = elem.OP;
        }

        let p = elem.P;
        let result = elem;
        let mappingJson = this.getMappingJson(item);
        if (mappingJson[p][this.op]) { //support inner-levels
            mappingJson[p] = mappingJson[p][this.op];
        }
        for (var key in mappingJson[p]) {
            //if(!result[key]){ //sometimes we want to OVERRIDE OP
            try {
                if (typeof mappingJson[p][key] === 'function') {
                    result[key] = mappingJson[p][key](item);
                } else {
                    result[key] = mappingJson[p][key];
                }
            } catch (e) {
                //console.log('unable to collect ' + key + ' for beacon, ignoring and moving on');
            }
            //}
        }

        return result;
    }

    /*
     * constructs beacon-ready parameters from a given json element
     * prioritizing given json element content over a generated 'global' beacon element
     */
    private json2Urlparams(jsonElem, item?) {
        let fullBeaconParamsArray = this.genBeaconParamsArray(item);
        let resultArr = {};

        for (var key in fullBeaconParamsArray) {
            if ((jsonElem[key] !== '') && (fullBeaconParamsArray[key] === '')) {
                resultArr[key] = jsonElem[key];
            } else if ((jsonElem[key] === '' || typeof jsonElem[key] === 'undefined') && (fullBeaconParamsArray[key] !== '')) {
                resultArr[key] = fullBeaconParamsArray[key];
            } else if ((jsonElem[key] !== '') && (fullBeaconParamsArray[key] !== '')) {
                resultArr[key] = jsonElem[key];
            }
        }

        let resultParams = '';
        for (var key2 in resultArr) {
            if (resultArr[key2]) {
                resultParams = resultParams + key2 + '=' + encodeURI(resultArr[key2]) + '&';
            }

        }
        return resultParams.substring(0, resultParams.length - 1);
    }

    genBeaconParamsArray(item?) {
        return {
            A: 'Primo_Local',
            G: this.getUserGroup(),
            I: this.getInstitutionCalculatedId(),
            IP: '',
            O: '',
            O1: '',
            O2: '',
            O3: '',
            O4: '',
            O5: getCurrentPCKey(),
            O6: '',
            O7: this.getUserLoginStatus(),
            O8: '',
            O9: getVid() || '',
            O10: '',
            O11: '',
            O12: this.getCampusStatus(),
            O13: '',
            O14: '',
            O15: '',
            O16: '',
            O17: '',
            O18: 'UI',
            O19: '',
            O20: '',
            O21: this.configurationUtil.isSuprima() ? 'SUP' : 'NUI',
            O22: '',
            O23: this.getReferrer(),
            O37: '',
            O38: '',
            O39: this.getInstitutionServer(item),
            O40: '',
            O41: '',
            O42: '',
            O43: '',
            O44: '',
            O45: '',
            O46: '',
            O47: '',
            O48: '',
            O49: this.getTimestampInFormat('dd/mmm/yyyy:HH:MM:ss'),
            O50: '',
            OP: '',
            P: '',
            RS: this.getResolution(),
            PV: '',
            PG: '',
            PCD: '',
            SPG: '',
            DL: '',
            S: this.getCurrentJWTDigest(),
            SRVR: getCurrentServer(),
            T: '',
            TYP: 'Page_View_' + getCurrentVersionNumber(),
            ctx_enc: '',
            ctx_tim: '',
            rfr_id: '',
            'rft.artnum': '',
            'rft.atitle': '',
            'rft.au': '',
            'rft.aucorp': '',
            'rft.auinit': '',
            'rft.auinit1': '',
            'rft.auinitm': '',
            'rft.aulast': '',
            'rft.ausuffix': '',
            'rft.btitle': '',
            'rft.coden': '',
            'rft.eisbn': '',
            'rft.eissn': '',
            'rft.epage': '',
            'rft.genre': '',
            'rft.isbn': '',
            'rft.issn': '',
            'rft.issue': '',
            'rft.jtitle': '',
            'rft.object_id': '',
            'rft.pages': '',
            'rft.part': '',
            'rft.quarter': '',
            'rft.sici': '',
            'rft.spage': '',
            'rft.ssn': '',
            'rft.volume': '',
            rft_dat: '',
            rft_id: '',
            rft_val_fmt: '',
            url_ctx_fmt: '',
            url_ver: ''
        };
    }

    getReferrer() {
        let referrer: string = '';
        let internalReferrer: string = 'Primo';
        let previousPageUrl = window.location.href; // Save the last location
        // This will be true after each reload because the constructor is called and there are 3 scenarios :
        // document.referrer is set to the external page when user get (by link) to primo page.
        // document.referrer is set to empty string when user get directly (not by link) to the page.
        // document.referrer is set to window.location when user refresh the page.
        if (this.needToGetReferrer) {
            previousPageUrl = (document.referrer) ? document.referrer : window.location.href;
        }
        if (previousPageUrl) {
            // For Internal beacon
            if (previousPageUrl.indexOf('/primo-explore/') > -1 || previousPageUrl.indexOf('/discovery/') > -1) {
                referrer = internalReferrer;
            }
            // For external beacon
            else {
                let url = new URL(previousPageUrl);
                referrer = url.origin;
                this.needToGetReferrer = false;            // We can avoid the referrer because it will be internal from now on
            }
        }
        return referrer;
    }

    /* === search/item related functions === */

    getOnlineOrPhysical(item) {
        if (angular.isDefined(item.beaconIsPhsical)) {
            if (item.beaconIsPhsical) {
                return 'physical';
            } else if (!item.beaconIsPhsical) {
                return 'online';
            }
        }
        return undefined;
    }

    getSourceOfTheRecord() {
        let thisTab = getTab(this.getSearchScope()).toUpperCase();
        let scopes = window.appConfig['primo-view'].scopes;

        for (var scope in scopes) { //iterate over scopes until you find the scope that matches this tab...
            let tab = scopes[scope].tab.toUpperCase();
            let thisSearchScope = this.getSearchScope().toUpperCase();
            let scopeId = scopes[scope]['scope-id'].toUpperCase();
            if (tab === thisTab && thisSearchScope === scopeId) {
                let types = scopes[scope].types;

                if ((types.indexOf('local') > -1) && ((types.indexOf('adaptor') > -1) || (types.indexOf('deep_search') > -1))) {
                    return 'blended'; //  blended when the scope type contains 'local' and also one of the types 'adaptor' and 'deep_search'
                } else if ((types.indexOf('deep_search') > -1) || ((types.indexOf('local') === -1) && (types.indexOf('adaptor') > -1))) {
                    return 'deep_search'; // deep_search when the scope type contains 'deep_search' (for Suprima) or when it contains only 'adaptor' (for Primo)
                } else {
                    return 'local';// the scope type is 'local' when it contains only 'local'
                }
            }
        }
        return undefined;
    }

    getServerTime(item?) {
        if (item && item.beaconO22) {
            return item.beaconO22;
        }
        if (!item) { //this is an action causing an underlying search, extract from search results
            return this.searchService.getResultObject().beaconO22;
        }
    }

    getSortType() {
        if (this.searchFieldsService.sortby === 'date' || this.searchFieldsService.sortby === 'date_d') {
            return 'dateNewest';
        }
        if (this.searchFieldsService.sortby === 'date2' || this.searchFieldsService.sortby === 'date_a') {
            return 'dateOldest';
        }
        return this.searchFieldsService.sortby;
    }

    getSearchScopeType(item?) {
        return this.getSourceOfTheRecord();
    }

    getRecordDataSource(item) {
        return item.pnx.search.sourceid || '';
    }

    get browseRecordSource() {
        return this.browseResultService.browseResult.pnx.search.sourceid || '';
    }

    getInstitutionServer(items) {
        if (this.configurationUtil.isSuprima() && window.appConfig['system-configuration'] && window.appConfig['system-configuration']['hostLB']) {
            let hostLB = window.appConfig['system-configuration']['hostLB'];
            hostLB = hostLB.replace(this.urlPrefixPattern, '');
            hostLB = hostLB.replace(this.urlSuffixPattern, '');
            return hostLB;
        } else {
            if (items && items.data && items.data[0] && items.data[0]['@id']) {
                let id = items.data[0]['@id'];
                let url = new URL(id);
                if (url && url.hostname) {
                    this.institutionServer = url.hostname;
                    return url.hostname;
                }
            } else if (this.institutionServer) {
                return this.institutionServer;
            } else {
                return getCurrentServer();
            }
        }
    }

    getInstitutionCalculatedId() {
        if (this.configurationUtil && this.configurationUtil.isSuprima()) {
            return getInstitutionId();
        } else {
            if (this.jwtUtilService && this.jwtUtilService.getDecodedToken().jwtAlternativeBeaconInstitutionCode) {
                return this.jwtUtilService.getDecodedToken().jwtAlternativeBeaconInstitutionCode;
            } else {
                console.log('Unable to find the JWT alternative beacon institution code.');
                return 'noJwtAlternativeBeaconInstitutionCode'; // sending an error message on institution because jwtAlternativeBeaconInstitutionCode doesn't exit
            }
        }
    }

    getSearchType() {
        if (this.searchStateService.getSearchObject().query) {
            return this.searchStateService.getSearchObject().query.replace(/[a-z]+,/, '').replace(/,.*/, '');
        }
        return undefined;
    }

    getSearchActionType() {
        //currently implemented only for voice search
        if (this.searchService && this.searchService.cameFromState == 'voiceSearch') {
            return 'voiceSearch';
        }
        return null;
    }

    getDBSearchType() {
        let databaseParam = this.searchStateService.getSearchObject().databases;
        if (databaseParam) {
            if (databaseParam.includes('letter,')) {
                return 'AtoZ';
            }
            if (databaseParam.includes('any,')) {
                return 'DB Search';
            }
            if (databaseParam.includes('category,')) {
                return 'DB Category';
            }
        }
        return 'Not Defined Search';
    }

    getDBSearchOP() {
        let databaseParam = this.searchStateService.getSearchObject().databases;
        if (databaseParam) {
            if (databaseParam.includes('letter,')) {
                return 'azdbAtoZ';
            }
            if (databaseParam.includes('category,')) {
                return 'azdbDbCategory';
            }
        }
        return 'azdb';
    }

    private getATOZSearchOP() {
        let journalsParam = this.searchStateService.getSearchObject().journals
        if (journalsParam) {
            if (journalsParam.includes('letter,')) {
                return 'atoz';
            }
            if (journalsParam.includes('category,')) {
                return 'atozCategory';
            }
        }
        return 'atoz';
    }

    getBrowseQuery() {
        return this.browseResultService.query ? encodeURIComponent(this.browseResultService.query) : undefined;
    }


    getGIDOfRecord(item) {
        if (item.pnx.facets.frbrtype[0] === "5") {
            return item.pnx.facets.frbrgroupid;
        }
    }


    getItemDataScope(item) {
        if (item.context === 'PC') {
            return item.pnx.search.scope;
        }
        return item.pnx.control.sourceid;
    }

    getIdOfRecord(item) {
        return item.pnx.control.recordid;
    }

    getTitleOfRecord(item) {
        return this.encodeAmpersand(get(item, 'pnx.search.title'));
    }

    getPublisherOfRecord(item) {
        return this.encodeAmpersand(get(item, 'pnx.display.publisher'));
    }

    encodeAmpersand(term) {
        if (Array.isArray(term)) {
            return term.map(t => t ? t.replace(/&/g, '%26') : t);
        }
        return term ? term.replace(/&/g, '%26') : term;
    }

    getIsCdiRecord(item) {
        let docid = this.$stateParams["docid"];
        if (docid && (docid.toLowerCase().startsWith("cdi_") || docid.toLowerCase().startsWith("tn_cdi_"))) {
            return true;
        }
        return undefined;
    }

    getIssnOfRecord(item) {
        return this.arrayToStringWithToken(item.pnx.addata.issn, ';');
    }

    getEIssnOfRecord(item) {
        return this.arrayToStringWithToken(item.pnx.addata.eissn, ';');
    }

    arrayToStringWithToken(array, token) {
        let value = "";
        if (array.length > 0) {
            let first = true;
            for (let i in array) {
                if (first) {
                    value = array[i];
                    first = false;
                } else {
                    value += token + array[i];
                }
            }
        }
        return value;
    }

    getJournalOfRecord(item) {
        let jtitle = "";
        if (item.pnx.facets.jtitle.length > 0) {
            jtitle = item.pnx.facets.jtitle[0];
        }
        jtitle = this.encodeAmpersand(jtitle);

        return jtitle;
    }

    /* === facet related functions === */

    private getFacetAsObj(facetArray) { //facetArray=[name, label, value, facetType, displayedType]
        return {
            name: facetArray[0],
            label: facetArray[1],
            value: facetArray[2],
            type: facetArray[3],
            displayedType: facetArray[4],
            operation: facetArray.slice(-1)[0]
        };
    }

    getFacetAddOrRemove(facet) {
        if (this.op === 'expandResults') {
            let pcAvailability = this.searchService.getSearchObject().pcAvailability;
            if (pcAvailability === 'false') {
                pcAvailability = false;
            }
            return pcAvailability ? 'Add' : 'Remove';
        }

        if (this.op === 'SearchCDIFullText') {
            return this.facetService.searchInFulltext ? 'Add' : 'Remove';
        }

        let facetArray = this.searchStateService.getSearchObject().facets;

        if (this.op === 'frbr' /*incase this is deeplink*/ || facet.name === 'frbrgroupid' /* incase this is facet*/) {
            for (var f in facetArray) {
                if (facetArray[f].name === 'frbrgroupid') {
                    return 'Add';
                }
            }
            return 'Remove';
        }

        if (facet.operation == 'add') {
            return 'Add'
        }

        for (var f in facetArray) {
            if ((facet.name === facetArray[f].name) &&
                (facet.label === facetArray[f].label) &&
                (facet.value === facetArray[f].value) &&
                (facet.facetType === facetArray[f].facetType) &&
                (facet.displayedType === facetArray[f].displayedType)) {
                return 'Add';
            }
        }
        return 'Remove';
    }

    getFacetAction(facet) { //facet = [name, label, value, facetType, displayedType]
        let facetType = this.getFacetType(facet);
        return 'facet' + facetType[0].toUpperCase() + facetType.slice(1);
    }

    getFacetValue(facet?) {
        if (!facet) {
            let facetArray = this.searchStateService.getSearchObject().facets;
            if (facetArray.length > 0) {
                facet = facetArray[facetArray.length - 1];
            }
        }
        if (facet.name === 'tlevel' || facet.name === 'rtype') {
            return facet.value;
        } else {
            return undefined;
        }
    }

    getFacetType(facet) {
        if (!facet) {
            let facetArray = this.searchStateService.getSearchObject().facets;
            return facetArray[facetArray.length - 1].type;
        } else if (facet.name === 'frbrgroupid') { // is this a 'showAllVersions' facet?
            return 'frbr';
        }
        if (facet.facetType) {
            return facet.facetType;
        }
        return facet.type;
    }

    getFacetName(facet?) {
        if (facet) {
            return facet.name;
        } else {// not sure in what case it will get to "else" but following the getFacetType logic just in case
            let facetArray = this.searchStateService.getSearchObject().facets;
            return facetArray[facetArray.length - 1].name;
        }
    }

    /* === favorites related functions === */

    getFavoritesAction(item?) {
        let ids;
        let area = this.userSessionManagerService.area as any[];
        ids = area.map((element) => {
            if (this.userSessionManagerService.isGuest()) {
                return element.pnx.control.recordid[0];
            }
            return element;
        });
        return (indexOf(ids, item.pnx.control.recordid[0]) !== -1 ? 'remove' : 'add');
    }


    /* === general params functions === */

    checkIfCitationTrail(operation: string) {
        if (operation != 'CitedByLink' && operation != 'CitationsLink') {
            return 'brief';
        }
        if (this.$state.$current.name === STATE_NAMES.CITATION_TRAILS) {
            return 'citationTrail'
        } else {
            return 'brief'
        }
    }

    getCurrentLocation() {
        let pathName = window.location.pathname;
        return pathName.substring(pathName.lastIndexOf("/") + 1);
    }

    getResolution() {
        return 'W' + window.screen.availWidth + 'H' + window.screen.availHeight;
    }

    getCampusStatus() {
        let campusStatus = '0';
        if (this.jwtUtilService.getDecodedToken().onCampus == 'true') {
            campusStatus = '1';
        }

        return campusStatus;
    }

    getStickyFacetsUsedOnZeroResults(items) {
        let stickyFacetsUsedOnZeroResults = undefined;
        if (this.getNumberOfResults(items) === '0') {
            if (this.searchStateService.getSearchObject().facets.length > 0) {
                stickyFacetsUsedOnZeroResults = '1';
            }
            else {
                stickyFacetsUsedOnZeroResults = '0';
            }
        }
        return stickyFacetsUsedOnZeroResults;
    }

    getUserGroup() {
        let decodedToken = this.jwtUtilService ? this.jwtUtilService.getDecodedToken() : undefined;
        if (!decodedToken) {
            return 'GUEST';
        }
        let userGroup = get(decodedToken, 'userGroup');
        if (!userGroup) {
            userGroup = 'GUEST';
        }

        return userGroup;
    }

    getPercentOfContentBySource(items?) {
        if (!items) {
            //lets try getting the items from the search service...
            items = this.searchService.getResultObject().data;
        }

        let jsonObj = {};

        for (var item in items) {
            let context = items[item].context;
            if (!jsonObj[context]) {
                jsonObj[context] = 0;
            }
            jsonObj[context] += 1;
        }

        return 'TOT:' + items.length +
            ';PR:' + ((jsonObj['L'] / items.length) * 100 || 0).toFixed(2) +
            ';PC:' + ((jsonObj['PC'] / items.length) * 100 || 0).toFixed(2) +
            ';EB:' + ((jsonObj['Ebsco'] / items.length) * 100 || 0).toFixed(2) +
            ';WC:' + ((jsonObj['WorldCat'] / items.length) * 100 || 0).toFixed(2) +
            ';OT:' + ((this.getOtherContentBySource(items) / items.length) * 100 || 0).toFixed(2);
    }

    private getOtherContentBySource(items) {
        let counter = 0;
        for (var item in items) {
            let context = items[item].context;
            if (!(isEqual(context, 'L')) &&
                !(isEqual(context, 'PC')) &&
                !(isEqual(context, 'v2v')) &&
                !(isEqual(context, 'Ebsco')) &&
                !(isEqual(context, 'WorldCat'))) {
                counter += 1;
            }
        }
        return counter;
    }

    getCurrentSearchTab() {
        return window.appConfig['view-translations'][this.$translate.use()]['scopes.option.' + this.searchFieldsService.scope] || '';
    }

    getNumberOfResults(items?) {
        let total = this.searchService.getResultObject().info.total;
        if (!total && (this.op === 'do' || this.$stateParams['mode'] === 'advanced')) {
            // on test for "basic search" action
            if (this.searchService.beaconResultsNumber) {
                return this.searchService.beaconResultsNumber;
            }
            let loadedNumberOfResults = get(this.searchService.getResultObject(), 'data.length');
            if (loadedNumberOfResults) {
                return loadedNumberOfResults;
            }
            return '0';
        }
        // retrurn the old way in case it's not a basic search, not ADELAIDEU institution or not zero results
        return total;
    }

    getBeaconSearchErrorMessage() {
        let beaconSearchErrorMessage = '';
        if (this.searchService) {
            let resultObject = this.searchService.getResultObject()
            if (resultObject && resultObject.info) {
                beaconSearchErrorMessage = resultObject.info.beaconSearchErrorMessage;
            }
        }
        return beaconSearchErrorMessage;
    }

    private isGoogleBot() {
        var botPattern = "(googlebot\/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis|HeadlessChrome)";
        var re = new RegExp(botPattern, 'i');
        var userAgent = navigator.userAgent;
        if (re.test(userAgent)) {
            return true;
        }
        else
            return false
    }

    getRecommendationCount(recType) {
        return this.searchService.getRecommendationCount(recType);
    }

    getSearchTerm() {
        if (this.searchStateService.getSearchObject().query) {
            return this.searchStateService.getSearchObject().query.replace(/[a-z]+,[a-z]+,/, '');
        }
        return undefined;
    }

    getViewItTimes() {
        if (!window.appPerformance.serverTimeLog['viewit']) {
            return 0;
        }

        return window.appPerformance.serverTimeLog['viewit'];

    }

    getPCTimes() {

        if (!window.appPerformance.serverTimeLog['pcDelivery']) {
            return 0;
        }

        return window.appPerformance.serverTimeLog['pcDelivery'];
    }

    getGetItTimes() {

        if (!window.appPerformance.serverTimeLog['PhysicalServiceIdCalc'] && !window.appPerformance.serverTimeLog['getLocItems']) {
            return 0;
        }

        if (window.appPerformance.serverTimeLog['getLocItems'] && window.appPerformance.serverTimeLog['getLocItems'] == -1
            && window.appPerformance.serverTimeLog['PhysicalServiceIdCalc'] && window.appPerformance.serverTimeLog['PhysicalServiceIdCalc'] == -1) {
            return -1;
        }

        let gTime = (window.appPerformance.serverTimeLog['getLocItems'] && window.appPerformance.serverTimeLog['getLocItems'] !== -1 ? parseInt(window.appPerformance.serverTimeLog['getLocItems']) : 0) +
            (window.appPerformance.serverTimeLog['PhysicalServiceIdCalc'] && window.appPerformance.serverTimeLog['PhysicalServiceIdCalc'] !== -1 ? parseInt(window.appPerformance.serverTimeLog['PhysicalServiceIdCalc']) : 0);
        return gTime;
    }

    private getAtozSearchTerm() {
        if (this.searchStateService.getSearchObject().journals || this.searchStateService.getSearchObject().databases) {
            let param = this.searchStateService.getSearchObject().journals || this.searchStateService.getSearchObject().databases;
            if (this.configurationUtil.isSuprima()) {
                // Extract last part after the last comma
                return param.substring(param.lastIndexOf(",") + 1);
            } else {
                return param.replace(/[a-z]+,/, '').replace(/&/g, '%26');
            }
        }
        return undefined;
    }

    getSuprimaAtozLang() {
        if (this.searchStateService.getSearchObject().journals || this.searchStateService.getSearchObject().databases) {
            let param = this.searchStateService.getSearchObject().journals || this.searchStateService.getSearchObject().databases;
                // extract language code "letter,en,L" -> "en"
                let parts = param.split(",");
                if (parts.length > 2) {
                    return parts[1]; // Return the second part (language code)
                }
        }
        return undefined;
    }

    getFieldSearched() {
        return this.searchStateService.getSearchObject().query.replace(/,.*/, '');
    }

    getFieldSearchedFromUrl() {
        return this.getParamFromQuery(0);
    }

    getSearchTermsFromUrl() {
        let searchTermsFromUrl = this.getParamFromQuery(2);
        if (!searchTermsFromUrl) {
            return searchTermsFromUrl;
        }
        if (Array.isArray(searchTermsFromUrl)) {
            return searchTermsFromUrl.map(term => term ? term.replace(/&/g, '%26') : term);
        }
        return searchTermsFromUrl.replace(/&/g, '%26');
    }

    getSearchTypeFromUrl() {
        return this.getParamFromQuery(1);
    }


    getParamFromQuery(i) {
        let queries = this.$stateParams['query'];
        if (queries) {
            queries = flatten([queries]);
            let param = queries.map((query) => {
                //arr contains elements from type 'any,contains,a,AND'
                let arr = query.split(',');
                if (i === 2) { // handling search term parameter
                    if (this.$stateParams['mode'] === 'advanced') {
                        if (arr.length > 4) { //advanced search and there was a comma in the query
                            return arr.slice(2, -1).join(",");
                        }
                    }
                    else if (arr.length > 3) { //simple search and there was a comma in the query
                        return arr.slice(2).join(",");
                    }
                }
                return arr[i];
            });
            return param;
        }
    }

    private getCollectionSearchTerm() {
        let query = this.$stateParams['query'];
        if (query) {
            query = query.split(',');
            query.splice(0, 2);
            query = query.join(',')
        }
        return query;
    }

    getSearchTab() {
        let searchTab = this.searchFieldsService.tab;
        if (!searchTab) {
            searchTab = this.$stateParams['tab'];
            if (!searchTab) {
                searchTab = this.searchStateService.getSearchObject().tab;
                if (!searchTab) {
                    searchTab = getTab(this.getSearchScope());
                }
            }
        }
        return searchTab;
    }


    getCurrentJWTDigest() {
        let key = this.storageUtil.sessionStorage.getItem('primoExploreJwt');
        return key ? md5(key) : 'NO_SESSION';
    }

    getUserLoginStatus() {
        return this.userSessionManagerService.isGuest() ? '0' : '1';
    }

    getCurrentLang() {
        return this.$translate.use();
    }

    getSearchScope() {
        let searchScope = this.searchFieldsService.scope;
        if (!searchScope) {
            let searchScopeFromParam = this.$stateParams['search_scope']
            if (searchScopeFromParam) {
                searchScope = searchScopeFromParam;
            }
        }
        return searchScope;
    }

    getResourceTypePreFilter() {
        //        let facets = this.searchStateService.getSearchObject().facets;
        //        let text ='';
        //        for (var facet in facets) {
        //            text += facets[facet].value;
        //        }
        //        return text;

        //TODO
        return 'All items';
    }

    getResourceTypePreFilterFromUrl() {
        let resourceType = 'All items'
        let preFilter = this.$stateParams['pfilter'];
        if (preFilter) {
            preFilter = flatten([preFilter]);
            preFilter.forEach((filter, index, array) => {
                let arr = filter.split(',');
                if (arr[0] === 'pfilter') {
                    resourceType = arr[2];
                }
            });
        }
        return resourceType;
    }    

    getTimestamp() {
        return new Date().getTime();
    }

    getTimestampInFormat(format) {
        let formattedDate = dateFormat(new Date(), format);
        return formattedDate ? formattedDate : new Date().getTime();
    }

    doBeaconReport(elem, item?, timestamp?) {
        if (this.getSearchService().isSearchInProgress()) { // *maybe* need to wait for search to finish before reporting
            this.doBeaconReportWaitForSearch(elem, item, timestamp);
        } else if (this.fullViewPageService.isGetItemInProgress()) { // *maybe* need to wait for fullview to finish before reporting
            this.doBeaconReportWaitForFullView(elem, item, timestamp);
        } else if (elem.p === 'refine') {
            this.doBeaconReportWaitForFacetSearch(elem, item = (item instanceof Array ? this.getFacetAsObj(item) : item), timestamp);
        } else if (elem.p === 'sort') {
            this.doBeaconReportWaitForSearch(elem, item, timestamp);
        } else {
            this._doBeaconReport(elem, item, timestamp); // report to beacon
        }
    }

    doBeaconReportWaitForFacetSearch(elem, item?, timestamp?) {
        let unregisterWatch = this.getScope().$watch(() => {
            return this.searchService.isSearchInProgress();
        },
            (newVal, oldVal) => {
                if (newVal === false && oldVal === true) {
                    let facetArray = this.searchStateService.getSearchObject().facets;
                    this._doBeaconReport(elem, (item || facetArray[facetArray.length - 1]), timestamp, true); // report to beacon
                    unregisterWatch();
                }
            });
    }

    doBeaconReportWaitForSearch(elem, item?, timestamp?) {
        let unregisterWatch = this.getScope().$watch(() => {
            return this.searchService.isSearchInProgress();
        },
            (newVal, oldVal) => {
                if (newVal === false && oldVal === true) {
                    this._doBeaconReport(elem, (item || this.searchStateService.getResultObject()), timestamp, true);  // report to beacon
                    unregisterWatch();
                }
            });
    }

    doBeaconReportWaitForFullView(elem, item?, timestamp?) {
        let unregisterWatch = this.getScope().$watch(() => {
            return this.fullViewPageService.isGetItemInProgress();
        },
            (newVal, oldVal) => {
                if (newVal === false && oldVal === true) {
                    this._doBeaconReport(elem, (item || this.fullViewPageService.currentItem), timestamp); // report to beacon
                    unregisterWatch();
                }
            });
    }

    getRARecordId(item) {
        return 'sourceId' === get(item,'label','') ? get(item,'value','') : '';
    }

    getRAQuestion(item) {
        return get(item,'question');
    }

    /*
     * generates a full beacon image, placing it on the page
     */
    _doBeaconReport(elem, item?, timestamp?, isSearch?) {

        if (window.appConfig['system-configuration'].GATHER_PAGE_STAT === 'N' || !this.beaconBaseUrl || this.getBeaconSearchErrorMessage() || this.isGoogleBot()) {
            return;
        }

        if (isJson(elem)) {
            elem = JSON.parse(elem);
        }

        elem = normalizeJson2UpperCase(elem);

        let bParamsJson = this.getParamsFromMapping(elem, item);
        let bParamsUrl = this.json2Urlparams(bParamsJson, item);

        let paramsArr = bParamsUrl.split('&');
        let regEx = /#/g
        if (isSearch && paramsArr) {
            let index = paramsArr.findIndex(x => x.split('=')[0] === 'O8'); // searching the index which including the search term
            if (index > -1) {
                let mySearchTermStr = paramsArr[index].replace(regEx, '%23');
                paramsArr[index] = mySearchTermStr;
                bParamsUrl = paramsArr.join('&');
            }
        }
        let delay = isSearch ? 2000 : 0;
        this.$timeout(() => { //measure time only after page is done rendering
            let searchResultDisplayed = get(window.appPerformance, 'timeStamps[\'search result displayed\']', undefined);
            let searchResultDisplayedInFull = get(window.appPerformance, 'timeStamps[\'search result displayed full view\']', undefined);
            let searchApiSend = get(window.appPerformance, 'timeStamps[\'search api send\']', undefined);
            let fullApiSend = get(window.appPerformance, 'timeStamps[\'full view api send\']', undefined);
            let focusTS = get(window.appPerformance, 'timeStamps[\'focusIn\']', undefined);
            let psl = get(window.appPerformance, 'serverTimeLog[\'BriefSearchDeltaTime\']', undefined);
            let pvesl = get(window.appPerformance, 'serverTimeLog[\'COMBINED_SEARCH_TIME\']', undefined);
            let confStart = get(window.appPerformance, 'timeStamps[\'before configuration api\']', undefined);
            let confEnd = get(window.appPerformance, 'timeStamps[\'after configuration api\']', undefined);
            let O22 = bParamsJson['O22'];
            let isDeepLink = bParamsJson['DL'] === 'Y';
            let isFull = bParamsJson['OP'] === 'openfull';
            let serverTime = psl || pvesl;
            let isInFocus = document.hasFocus() || false;
            let useSearchMetrics = (isSearch && searchResultDisplayed && searchApiSend && searchApiSend > 0 && (searchResultDisplayed > searchApiSend));
            let timeBySearchMetrics = searchResultDisplayed - searchApiSend;
            let nowBeaconTimeStamp = new Date().getTime();

            let timeByBeaconTimeStamps = nowBeaconTimeStamp - timestamp - delay;

            let time = useSearchMetrics ? timeBySearchMetrics : timeByBeaconTimeStamps;
            if (isFull) {
                time = searchResultDisplayedInFull - timestamp;
                if (isDeepLink) {
                    let downloadIndex = get(window.appPerformance, 'timeStamps[\'index.html\']', timestamp);
                    window.appPerformance.timeStamps['index.html'] = undefined;
                    time = searchResultDisplayed - downloadIndex;
                }
            }
            let lateFocusSearch = (focusTS && searchApiSend && focusTS > searchApiSend);
            let lateFocusFull = (focusTS && fullApiSend && focusTS > fullApiSend);
            let lateFocus = lateFocusSearch || lateFocusFull;
            if (!isInFocus || lateFocus) {
                time = 1;
                if (isSearch && serverTime) {
                    // this is server time performance w/o rendering - as the window is not in focus and browsers behave unexpectedly when not in focus
                    let sTime = parseInt(serverTime) ? parseInt(serverTime) : 0;
                    time = sTime + 400; //400 is the assumed rendering time;
                } else {
                    if (!isSearch && O22) {
                        let o22Time = parseInt(O22) ? parseInt(O22) : 0;
                        time = o22Time + 400; //400 is the assumed rendering time;
                    }
                }
            }

            if(!timestamp){
                timestamp = 1; // PRM-46989
            }

            if (!time || isNaN(time) || time < 0) {
                time = 1;
            }

            let url = this.beaconBaseUrl + '?' + bParamsUrl + (timestamp || isSearch ? '&T=' + time : '') + '&ignore=' + (new Date().getTime());
            //let templateString = '<img src='+url+'style="display:none"/>';
            //console.log('beaconURL: '+templateString);
            this.placeImageOnPage(url);
        }, delay);
    }

    private placeImageOnPage(url: string) {
        let image = document.createElement('img');
        image.src = url;
        image.style.display = 'none';
        image.alt = 'Powered by Apache'
        document.getElementById('beaconPlaceHolder').appendChild(image);
    }

    private getCitationTrailExpandAction(){
        if (this.op === 'expandResults') {
            return this.citationTrailsExpandButtonService.expandMyResultsForCitationTrail ? 'Add' : 'Remove';
        }
    }


}


export function beacon(element: any) {
    return (target: Object, propertyKey: string, descriptor: TypedPropertyDescriptor<any>) => {

        let originalMethod;

        if (descriptor.set) { // takes care of getters and setters
            originalMethod = descriptor.set;
            descriptor.set = decoFunc;
        } else {
            originalMethod = descriptor.value;
            descriptor.value = decoFunc;
        }

        function decoFunc(...args: any[]) {

            let startTime = new Date().getTime();
            this.primolyticsService.originalMethodArgs = args;

            let result = originalMethod.apply(this, args); // run and store the result
            this.primolyticsService.getScope().$evalAsync(() => { // run async beacon report
                let item = this[element['item']] || this.item || this.items || this.result || this.results || (!isEmpty(args) ? (args.length === 1 ? args[0] : args) : undefined);
                if(get(element,'op') === 'displayCollection' && get(args,'[0].name')){
                    item = get(args,'[0]');
                }
                this.primolyticsService.doBeaconReport(element, item, startTime);
            });


            return result; // return the result of the original method
        };
        return descriptor;
    };

}

export function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export function normalizeJson2UpperCase(elem) {
    let key, keys = Object.keys(elem);
    let n = keys.length;
    let newobj = {};
    while (n--) {
        key = keys[n];
        newobj[key.toUpperCase()] = elem[key];
    }
    return newobj;
}

export function urlContainsParams(url, ...args: string[]) {
    for (var arg in args) {
        if (url.indexOf(args[arg]) === -1) {
            return false;
        }
    }
    return true;
}

//put here all angular1 modules the service is using
export default [uiRouterModule];



// WEBPACK FOOTER //
// ./src/main/webapp/components/analytics/primolytics.service.ts